<template>
    <el-dialog
        title="请输入新机IMEI号"
        v-model="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form >
          <el-form-item  prop="iemi" >
              <el-input  v-model="form.imei"  autocomplete="off"></el-input>
        </el-form-item>
            <div class="buttom-box">
                    <el-button type="primary" @click="AddClick()" :loading="loading">提交</el-button>
                    <el-button @click="handleClose">返回</el-button>
                </div>
    </el-form>
        
    </el-dialog>
</template>
<script>
import { deviceHuanji} from '@/assets/api/api'
// import { ElMessage } from 'element-plus'

export default {
    components: {
    },
    props: ['HuanjiObj'],
    data() {

        return {
            dialogVisible: true,
            loading:false,
            title:'',
            form:{
                imei:'',
            },
            cardid:"",
            schoolList:[],
          
        }

    },
    created(){
       
    },
    mounted(){
            
            console.log(this.HuanjiObj,1111);
    },
    methods:{
        handleClose() {
            this.$emit('HuanjiShowClick')
      },
      AddClick(){
        this.deviceClick()
    },
    deviceClick(){
        this.loading = true
    deviceHuanji(this.HuanjiObj.deviceId,this.form.imei,this.HuanjiObj.memberId).then((res)=> {
        // console.log(res,'换机成功');
        this.$message({
                    type: 'success',
                    message: '换机成功'
                });
        this.loading = false
        this.handleClose()
        }).catch((err)=> {
            // console.log(err,'换机失败');
            this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
          })
      }
    }
    }




</script>
<style  scoped lang="scss">
    /deep/ {
        .el-input--small .el-input__wrapper{
            height: 35px;
            line-height: 35px;
            text-align: center;
            width: 280px;
        }
        .el-input__inner{
            // width: 10px !important;
        }
        .buttom-box {
        // text-align: center;
        // margin-left: 180px;

    }
    
    .el-form-item--small{
        width: 70% !important;
    }
    }
</style>